import { Injectable } from '@angular/core';
import {
  ERROR_ADMIN_ROLE_PERMISSION_CODE,
  ERROR_PASSWORD_MISMATCH_CODE,
  ERROR_PSS_RESET_LIMIT_EXC_CODE,
  ERROR_UNKNOWN_CODE,
  ERROR_USERNAME_EXISTS_CODE,
  ERROR_USER_NOT_AUTHORIZED_CODE,
  ERROR_USER_NOT_FOUND_CODE,
  ERROR_STORE_BULK_CREATE_LIMIT_CODE,
  ERROR_STORE_INCONSISTENT_COMPANY_ID_CODE,
  ERROR_BUYER_PAYMENT_SOURCE_REMOVE_CODE,
  ERROR_LONG_NOT_ENABLED_CODE,
  ERROR_COMPANY_DISABLED_CODE,
  ERROR_COMPANY_PARTIALLY_ENABLED_CODE,
  ERROR_CORRUPTED_FILE_CODE,
  ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_CODE,
  ERROR_COMPANY_BNPL_LONG_DISABLED_CODE,
  ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_CODE,
  ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_CODE,
  ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_CODE,
  ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_CODE,
  ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_CODE,
} from '../shared/constants/operationals';
import {
  ERROR_ADMIN_ROLE_PERMISSION_MESSAGE,
  ERROR_PASSWORD_MISMATCH_MESSAGE,
  ERROR_PSS_RESET_LIMIT_EXC_MESSAGE,
  ERROR_UNKNOWN_MESSAGE,
  ERROR_USERNAME_EXISTS_MESSAGE,
  ERROR_USER_NOT_AUTHORIZED_MESSAGE,
  ERROR_USER_NOT_FOUND_MESSAGE,
  ERROR_STORE_BULK_CREATE_LIMIT_MESSAGE,
  ERROR_STORE_INCONSISTENT_COMPANY_ID_MESSAGE,
  ERROR_BUYER_PAYMENT_SOURCE_REMOVE_MESSAGE,
  ERROR_LONG_NOT_ENABLED_MESSAGE,
  ERROR_COMPANY_DISABLED_MESSAGE,
  ERROR_COMPANY_PARTIALLY_ENABLED_MESSAGE,
  ERROR_CORRUPTED_FILE_MESSAGE,
  ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_MESSAGE,
  ERROR_COMPANY_BNPL_LONG_DISABLED_MESSAGE,
  ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE,
  ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE,
  ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_MESSAGE,
  ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_MESSAGE,
  ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_MESSAGE,
} from '../shared/constants/translations';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  managed_error_codes: string[] = [
    ERROR_PASSWORD_MISMATCH_CODE,
    ERROR_USER_NOT_FOUND_CODE,
    ERROR_USERNAME_EXISTS_CODE,
    ERROR_PSS_RESET_LIMIT_EXC_CODE,
    ERROR_USER_NOT_AUTHORIZED_CODE,
    ERROR_ADMIN_ROLE_PERMISSION_CODE,
    ERROR_STORE_BULK_CREATE_LIMIT_CODE,
    ERROR_STORE_INCONSISTENT_COMPANY_ID_CODE,
    ERROR_BUYER_PAYMENT_SOURCE_REMOVE_CODE,
    ERROR_LONG_NOT_ENABLED_CODE,
    ERROR_COMPANY_DISABLED_CODE,
    ERROR_COMPANY_PARTIALLY_ENABLED_CODE,
    ERROR_CORRUPTED_FILE_CODE,
    ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_CODE,
    ERROR_COMPANY_BNPL_LONG_DISABLED_CODE,
    ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_CODE,
    ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_CODE,
    ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_CODE,
    ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_CODE,
    ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_CODE,
  ];

  constructor(private readonly dialog_service: DialogService) {}

  processGenericApiError(error: any): void {
    const processed_error: SplittypayError = this.preProcessApiError(error);
    this.processApiError(processed_error.code, processed_error.message);
  }

  preProcessApiError(error: any): SplittypayError {
    return error.response
      ? {
          code: error.response.data.code,
          message: error.response.data.description || error.response.data.message,
        }
      : { code: ERROR_UNKNOWN_CODE, message: ERROR_UNKNOWN_MESSAGE };
  }

  processApiError(error_code: string, error_message?: string): void {
    if (this.managed_error_codes.includes(error_code)) {
      this.manageError(error_code);
    }

    if (!this.managed_error_codes.includes(error_code) && error_message) {
      this.dialog_service.openErrorDialog(error_message);
    }

    if (!this.managed_error_codes.includes(error_code) && !error_message) {
      this.dialog_service.openErrorDialog(ERROR_UNKNOWN_MESSAGE);
    }
  }

  manageError(error_code: string): void {
    switch (error_code) {
      case ERROR_PASSWORD_MISMATCH_CODE:
        this.dialog_service.openErrorDialog(ERROR_PASSWORD_MISMATCH_MESSAGE);
        break;
      case ERROR_USER_NOT_FOUND_CODE:
        this.dialog_service.openErrorDialog(ERROR_USER_NOT_FOUND_MESSAGE);
        break;
      case ERROR_USER_NOT_AUTHORIZED_CODE:
        this.dialog_service.openErrorDialog(ERROR_USER_NOT_AUTHORIZED_MESSAGE);
        break;
      case ERROR_USERNAME_EXISTS_CODE:
        this.dialog_service.openErrorDialog(ERROR_USERNAME_EXISTS_MESSAGE);
        break;
      case ERROR_PSS_RESET_LIMIT_EXC_CODE:
        this.dialog_service.openErrorDialog(ERROR_PSS_RESET_LIMIT_EXC_MESSAGE);
        break;
      case ERROR_ADMIN_ROLE_PERMISSION_CODE:
        this.dialog_service.openErrorDialog(ERROR_ADMIN_ROLE_PERMISSION_MESSAGE);
        break;
      case ERROR_STORE_BULK_CREATE_LIMIT_CODE:
        this.dialog_service.openErrorDialog(ERROR_STORE_BULK_CREATE_LIMIT_MESSAGE);
        break;
      case ERROR_STORE_INCONSISTENT_COMPANY_ID_CODE:
        this.dialog_service.openErrorDialog(ERROR_STORE_INCONSISTENT_COMPANY_ID_MESSAGE);
        break;
      case ERROR_BUYER_PAYMENT_SOURCE_REMOVE_CODE:
        this.dialog_service.openErrorDialog(ERROR_BUYER_PAYMENT_SOURCE_REMOVE_MESSAGE);
        break;
      case ERROR_LONG_NOT_ENABLED_CODE:
        this.dialog_service.openErrorDialog(ERROR_LONG_NOT_ENABLED_MESSAGE);
        break;
      case ERROR_COMPANY_DISABLED_CODE:
        this.dialog_service.openErrorDialog(ERROR_COMPANY_DISABLED_MESSAGE);
        break;
      case ERROR_COMPANY_PARTIALLY_ENABLED_CODE:
        this.dialog_service.openErrorDialog(ERROR_COMPANY_PARTIALLY_ENABLED_MESSAGE);
        break;
      case ERROR_CORRUPTED_FILE_CODE:
        this.dialog_service.openErrorDialog(ERROR_CORRUPTED_FILE_MESSAGE);
        break;
      case ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_CODE:
        this.dialog_service.openErrorDialog(ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_MESSAGE);
        break;
      case ERROR_COMPANY_BNPL_LONG_DISABLED_CODE:
        this.dialog_service.openErrorDialog(ERROR_COMPANY_BNPL_LONG_DISABLED_MESSAGE);
        break;
      case ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_CODE:
        this.dialog_service.openErrorDialog(ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE);
        break;
      case ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_CODE:
        this.dialog_service.openErrorDialog(ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE);
        break;
      case ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_CODE:
        this.dialog_service.openErrorDialog(ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_MESSAGE);
        break;
      case ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_CODE:
        this.dialog_service.openErrorDialog(ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_MESSAGE);
        break;
      case ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_CODE:
        this.dialog_service.openErrorDialog(ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_MESSAGE);
        break;
      default:
        this.dialog_service.openErrorDialog(ERROR_UNKNOWN_MESSAGE);
        break;
    }
  }
}

export interface SplittypayError {
  code: string;
  message: string;
}
